import RouteEnum from "constants/RouteEnum";
import React from "react";
import SottosezioneModel from "stores/contenuto/models/SottosezioneModel";
import BaseSubsectionCard from "./BaseSubsectionCard";
import BaseSubsectionDefault from "./BaseSubsectionDefault";

interface IProps {
    subsection: SottosezioneModel;
    redirectToPage: (page: RouteEnum) => void;
}
interface IState {}

class BaseSubsection extends React.Component<IProps, IState> {
    public render(): JSX.Element {
        const { subsection, redirectToPage } = this.props;

        let SubsectionComponent;
        switch (subsection.codiceStileSottosezione) {
            case "CRD":
                SubsectionComponent = BaseSubsectionCard;
                break;
            case "NUL":
            default:
                SubsectionComponent = BaseSubsectionDefault;
                break;
        }

        let background = "";
        switch (this.props.subsection.codiceSfondoSottosezione) {
            case "PRI":
                background = "bg-ccq-lightyellow border-ccq-blue";
                break;
            case "SEC":
                background = "bg-ccq-lightblue border-ccq-blue";
                break;
            case "TER":
                background = "bg-ccq-blue border-ccq-blue text-white";
                break;
        }

        return <SubsectionComponent subsection={subsection} background={background} redirectToPage={redirectToPage} />;
    }
}

export { BaseSubsection as Unconnected };
export default BaseSubsection;
